import type { ReactNode } from "react";

type Kind = "info" | "success" | "error";

const styles: Record<Kind, string> = {
  info: "border-brand/20 bg-brand-tint/40 text-brand-dark",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  error: "border-accent/30 bg-accent/5 text-accent-dark",
};

export function Alert({
  kind = "info",
  children,
}: {
  kind?: Kind;
  children: ReactNode;
}) {
  return (
    <div
      role={kind === "error" ? "alert" : "status"}
      className={`rounded-md border px-4 py-3 text-sm ${styles[kind]}`}
    >
      {children}
    </div>
  );
}
